import { Bones, media } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const DetailsSummary = styled.ul`
  margin-top: ${(props) => props.theme.x2spacePx}px;
  li {
    margin-top: ${(props) => props.theme.x1space}rem;
    &:first-child {
      margin-top: 0;
    }
    > span {
      font-weight: bold;
    }
  }
`;

export const CompanyIconSkeleton = styled(Bones)`
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  height: 80px;
  width: 80px;

  ${media.lgUp`
      height: 100px;
      width: 100px;
  `}
`;
